// Backend 허용 목록과 동일한 내부 상품 식별값을 한 곳에서 관리한다.
export const QUICK_CASH_PRODUCT_CODE = 'quick-cash-20000';
export const QUICK_CASH_PRODUCT_NAME = 'Quick Cash 20000';
// Quick Cash 전용 신청 정책은 일반 신청 화면에 주입하지 않고 이 상품 폴더에서만 관리한다.
export const QUICK_CASH_FIXED_LOAN_AMOUNT = 20000;
export const QUICK_CASH_APPLY_TERM_OPTIONS = Object.freeze([
  Object.freeze({ value: 18, label: '18個月' }),
  Object.freeze({ value: 24, label: '24個月' }),
  Object.freeze({ value: 36, label: '36個月' }),
]);
// 기존 register draft와 충돌하지 않는 Quick Cash 전용 저장 키다.
export const QUICK_CASH_DRAFT_KEY = 'quick_cash_20000_draft_v1';
export const QUICK_CASH_DRAFT_SCHEMA_VERSION = 1;
